import React from "react";
import StaticPage from "./StaticPage";
import { COMPANY } from "@/lib/siteConfig";

const UPDATED = "3 August 2026";

export default function Cookies() {
  return (
    <StaticPage
      title="Cookie Policy"
      subtitle={`Last updated: ${UPDATED}`}
    >
      <p>
        This Cookie Policy explains how {COMPANY.name} uses cookies and
        similar technologies when you visit our website or use the
        SchoolLane platform. It should be read together with our{" "}
        <a href="/privacy">Privacy Policy</a>.
      </p>

      <h2>1. What is a cookie?</h2>
      <p>
        A cookie is a small text file that a website places on your device
        to remember information about you. Similar technologies — such as
        local storage and pixels — work in comparable ways. In this policy,
        we refer to all of them together as "cookies".
      </p>

      <h2>2. Types of cookies we use</h2>

      <h3>2.1 Essential cookies</h3>
      <p>
        These cookies are strictly necessary for the platform to function.
        They keep you signed in, protect against cross-site request forgery
        and enforce security controls such as rate limiting. Without these
        cookies, the platform will not work correctly. You cannot disable
        them through the platform interface, but you can control them via
        your browser settings.
      </p>

      <h3>2.2 Analytics cookies</h3>
      <p>
        We use analytics cookies to understand how the platform is used,
        which pages are most helpful and where users encounter friction.
        These cookies collect information in an aggregated form and do not
        identify individual users to third parties.
      </p>

      <h3>2.3 Third-party services</h3>
      <p>
        Some cookies are set by trusted third-party services that help us
        run the platform — for example, our website analytics provider and
        our transactional email provider. These providers only receive the
        minimum information required for the specific service they perform,
        and always under written data-protection commitments.
      </p>

      <h2>3. Browser cookie controls</h2>
      <p>
        Most modern browsers give you fine-grained control over cookies.
        You can accept, reject or delete cookies through your browser
        settings, and you can set your browser to alert you whenever a
        cookie is offered. Please note that if you disable essential
        cookies, parts of the SchoolLane platform will not function
        correctly.
      </p>
      <p>Common browser help pages:</p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
        <li><a href="https://support.apple.com/en-in/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Apple Safari</a></li>
        <li><a href="https://support.microsoft.com/microsoft-edge" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
      </ul>

      <h2>4. User consent</h2>
      <p>
        By continuing to use the SchoolLane platform, you consent to our
        use of essential cookies as described above. For analytics and
        non-essential cookies, you may withdraw consent at any time by
        adjusting your browser settings or by contacting us directly.
      </p>

      <h2>5. Changes to this policy</h2>
      <p>
        We may update this Cookie Policy from time to time. The most
        recent version will always be available on this page.
      </p>

      <h2>6. Contact</h2>
      <p className="not-prose">
        <strong>{COMPANY.name}</strong><br />
        {COMPANY.address.line1}<br />
        {COMPANY.address.line2}<br />
        {COMPANY.address.line3}<br />
        Phone: <a href={COMPANY.phoneHref}>{COMPANY.phone}</a><br />
        Email: <a href={COMPANY.emailHref}>{COMPANY.email}</a>
      </p>
    </StaticPage>
  );
}
